const BatteryCurrentType = {
  AC: 'AC',
  DC: 'DC',
  AC_DC: 'AC_DC',
};

export default BatteryCurrentType;
